import script from "./patientPage.vue?vue&type=script&setup=true&lang=js"
export * from "./patientPage.vue?vue&type=script&setup=true&lang=js"

import "./patientPage.vue?vue&type=style&index=0&id=0fe737ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe737ea"]])

export default __exports__